const SLIDE_TRANSITION_SPEED = 600

const styles = {
    SLIDE_TRANSITION_SPEED,
    root: {
        width: '100%',
        position: 'relative',
        sx: {
            '.swiper, .swiper-wrapper': {
                height: '100%'
            },
            '.swiper-slide': {
                height: 'auto'
            },
            '.swiper-slide > *': {
                height: '100%'
            }
        }
    },
    /* Inside the Swiper, hide the GDIContentTileBlock content layer so text
     * does NOT slide with the image. Layout (height, aspect ratio) is
     * preserved via `visibility: hidden`. The text is rendered separately in
     * the overlay layer below and its opacity tracks each slide's per-slide
     * `progress` so the fade follows the slide's actual on-screen position
     * (drag, autoplay, programmatic nav). */
    swiperHideContent: {
        height: '100%',
        sx: {
            '& > [data-block-type="GDIContentTileBlock"]': {
                height: '100%'
            },
            '.swiper-slide &': {
                height: '100%'
            },
            '[data-gdi-content-layer="content"]': {
                visibility: 'hidden'
            }
        }
    },
    contentOverlay: {
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none'
    },
    /* Initial opacity is 1 for the displayed slide and 0 for the rest;
     * after mount, opacity is updated imperatively from Swiper's
     * onProgress callback (no CSS transition — the value changes per
     * frame so a transition would lag behind the drag). */
    contentOverlaySlide: ({isActive}) => ({
        position: 'absolute',
        inset: 0,
        opacity: isActive ? 1 : 0,
        sx: {
            '[data-block-type="GDIImageBlock"], [data-block-type="GDIVideoBlock"]': {
                visibility: 'hidden'
            },
            /* The per-tile tooltip is rendered inside each Swiper slide
             * (so it physically slides with its tile via Swiper's transform).
             * Hide the duplicate copy that lives in this stationary overlay
             * layer so we don't see two tooltips during a swipe and the
             * tooltip never fades with the overlay opacity. */
            '[data-gdi-tile-tooltip="true"]': {
                display: 'none'
            },
            '[data-gdi-content-layer="content"]': {
                pointerEvents: isActive ? 'auto' : 'none'
            }
        }
    }),
    arrowIcon: ({direction, size}) => ({
        boxSize: size,
        transform: direction === 'right' ? 'rotate(180deg)' : undefined
    }),
    arrowIconPath: (color) => ({
        stroke: color,
        strokeLinecap: 'square'
    }),
    mobileHitArea: {
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        display: {base: 'flex', lg: 'none'}
    },
    mobileHitButton: {
        flex: '1',
        bg: 'transparent',
        border: 0,
        p: 0,
        m: 0,
        cursor: 'pointer'
    },
    mobileNav: {
        position: 'absolute',
        left: '16px',
        right: '16px',
        bottom: '8px',
        gap: '4px',
        height: '2px',
        zIndex: 2,
        display: {base: 'flex', lg: 'none'},
        pointerEvents: 'auto'
    },
    mobileNavButton: {
        flex: '1',
        height: '2px',
        bg: 'webBasic.400',
        overflow: 'hidden',
        border: 0,
        p: 0,
        m: 0,
        cursor: 'pointer'
    },
    mobileNavFill: ({isActive, initialMobileFillPct}) => ({
        height: '100%',
        bg: 'webTheme.strokeReverse',
        width: `${isActive ? initialMobileFillPct : 0}%`
    }),
    tooltipControl: (top) => ({
        position: 'absolute',
        top,
        left: {base: '16px', lg: '24px'},
        zIndex: 3
    }),
    desktopTeaser: {
        position: 'absolute',
        right: '24px',
        bottom: '63px',
        color: 'white',
        maxWidth: '342px',
        width: '100%',
        zIndex: 1,
        display: {base: 'none', lg: 'block'},
        pointerEvents: 'none'
    },
    teaserEyebrow: {
        color: 'white',
        mb: '10px'
    },
    teaserRow: {
        justifyContent: 'space-between',
        gap: 4,
        mb: 5,
        alignItems: 'center'
    },
    teaserTitle: {
        color: 'white'
    },
    desktopControls: {
        alignItems: 'center',
        gap: '16px',
        flexWrap: 'nowrap',
        sx: {pointerEvents: 'auto'}
    },
    arrowButton: {
        variant: 'unstyled',
        boxSize: '40px',
        minW: '40px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        cursor: 'pointer',
        borderRadius: 0,
        _hover: {
            color: 'webTheme.iconPrimary',
            bg: 'webTheme.backgroundDefault',
            boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)'
        }
    },
    desktopProgressTrack: {
        position: 'relative',
        width: '100%',
        height: '2px',
        backgroundColor: 'webBasic.400',
        overflow: 'hidden'
    },
    desktopProgressFill: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        backgroundColor: 'white',
        width: '0%'
    }
}

export default styles
